import React, { SVGProps } from 'react'

export const IconExclamation = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="2" height="10" viewBox="0 0 2 10" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.70078 0.999805C1.70078 0.613205 1.38738 0.299805 1.00078 0.299805C0.614182 0.299805 0.300781 0.613205 0.300781 0.999805V5.9998C0.300781 6.3864 0.614182 6.6998 1.00078 6.6998C1.38738 6.6998 1.70078 6.3864 1.70078 5.9998V0.999805ZM1.00078 9.8C1.38738 9.8 1.70078 9.4866 1.70078 9.1C1.70078 8.7134 1.38738 8.4 1.00078 8.4C0.614182 8.4 0.300781 8.7134 0.300781 9.1C0.300781 9.4866 0.614182 9.8 1.00078 9.8Z"
        fill="currentColor"
      />
    </svg>
  )
}
